export default __webpack_public_path__ + "static/1-b938b0cf40b3cff7cfeb3cdceef2528c.jpeg";